import { createPlugin } from '@backstage/core-plugin-api';

import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { TechdocsSupportBox } from './components/TechdocsSupport';

export const techdocssupportPlugin = createPlugin({
  id: 'techdocssupport',
});

export const TechdocssupportPage = techdocssupportPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechdocssupportPage',
    location: TechDocsAddonLocations.Header,
    component: TechdocsSupportBox,
  }),
);
